<fieldset>
	<br/>
	<app-add-tik-num *ngFor="let tikNum of tiknumFormArray.controls; let i=index" [index]="i" [tikNum]="tikNum" 
	 (removed)="tiknumFormArray.removeAt($event)" [qID]="qID" [displayErrors]="displayErrors" [titles]="titles" (change)="emitTikNumChanges($event)"
	 [ph]="ph" [displayX]="tiknumFormArray.length>1">
	</app-add-tik-num>
</fieldset>

<div class="d-flex justify-content-center text-center">
	<div *ngIf="tiknumFormArray.length > 0 && tiknumFormArray.length < maxTikNumArrayLength" class="m-add-line-btn" (click)="addTikNum()" 
		role="button" tabindex="0" 
		(keypress)="simulateClick($event)">
		<span>{{buttons[0]|translate}}</span>
	</div>
	<div *ngIf="tiknumFormArray.length === 0" 
	class="m-add-line-btn" (click)="addTikNum()" 
	role="button" tabindex="0" 
	(keypress)="simulateClick($event)">
		<i class="fa fa-plus" aria-hidden="true"></i>
		<span>{{buttons[0]|translate}}</span>
	</div>
</div>
<br/>



// WEBPACK FOOTER //
// ./src/app/internal-tik-num-array/internal-tik-num-array.component.html